exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#container {\n  width: 100%;\n  padding: 0;\n  background: #fff; }\n\n.items {\n  width: 600px;\n  height: 400px;\n  background: #ECECEC; }\n\n#left, #right {\n  margin: 30px; }\n\n.ng2-carouselamos-wrapper[_ngcontent-c2] {\n  overflow: inherit;\n  width: 100% !important; }\n\n.container {\n  background: #eee;\n  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  color: #000;\n  margin: 0;\n  padding: 0; }\n\n.swiper-container {\n  width: 100%; }\n\n.swiper-slide {\n  text-align: center;\n  font-size: 18px;\n  background: #fff;\n  /* Center slide text vertically */\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -ms-flex-align: center;\n  align-items: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/app/imageCarousel/image-carousel.component.scss
// module id = ../../../../../src/app/imageCarousel/image-carousel.component.scss
// module chunks = 1